import { env } from "../../env";
import Turnstile from "./Turnstile";
import {
  Button,
  Alert as MuiAlert,
  TextField as MuiTextField,
  Stack,
} from "@mui/material";
import { spacing } from "@mui/system";
import { Formik } from "formik";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import * as Yup from "yup";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function SignIn({ onSubmit }) {
  const turnstileEnabled = Boolean(env.REACT_APP_TURNSTILE_SITE_KEY);
  const validationSchema = Yup.object().shape({
    email: Yup.string().max(255).required("Email is required"),
    password: Yup.string().max(255).required("Password is required"),
    turnstileToken: turnstileEnabled
      ? Yup.string().required("Captcha verification is required")
      : Yup.string(),
  });

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        submit: false,
        turnstileToken: "",
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={onSubmit}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        setFieldValue,
        values,
      }) => {
        return (
          <form noValidate onSubmit={handleSubmit}>
            {errors.submit && (
              <Alert mt={2} mb={3} severity="warning">
                {errors.submit}
              </Alert>
            )}
            <TextField
              autoFocus
              type="email"
              name="email"
              label="Email"
              value={values.email}
              error={Boolean(touched.email && errors.email)}
              fullWidth
              helperText={touched.email && errors.email}
              onBlur={handleBlur}
              onChange={handleChange}
              my={2}
              required
              role="signin-email-input"
            />
            <TextField
              type="password"
              name="password"
              label="Password"
              value={values.password}
              error={Boolean(touched.password && errors.password)}
              fullWidth
              helperText={touched.password && errors.password}
              onBlur={handleBlur}
              onChange={handleChange}
              my={2}
              required
              role="signin-password-input"
            />
            <Turnstile
              error={errors.turnstileToken}
              onTokenChange={(token) => setFieldValue("turnstileToken", token)}
            />
            <Stack direction="column" spacing={2} mt={2}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                role="signin-button"
              >
                Sign in
              </Button>
              <Link to="/auth/sign-up">
                <Button
                  type="button"
                  fullWidth
                  variant="outlined"
                  color="primary"
                  role="signup-button"
                >
                  Sign up
                </Button>
              </Link>
              <Button
                component={Link}
                to="/auth/forgot-password"
                fullWidth
                color="primary"
              >
                Forgot password?
              </Button>
            </Stack>
          </form>
        );
      }}
    </Formik>
  );
}

export default SignIn;
